function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: 0.528,
  y1: 0.507,
  x2: 1.184,
  y2: 0.668,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.95,
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-2",
  x1: 0.514,
  y1: 0.779,
  x2: 0.461,
  y2: -0.279,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-3",
  x1: 0.521,
  y1: 1.133,
  x2: 0.467,
  y2: -0.473,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-4",
  x1: 2.944,
  y1: 98.494,
  x2: 2.889,
  y2: 58.447,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.99,
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-5",
  x1: 4.508,
  y1: 103.127,
  x2: 4.417,
  y2: 60.38,
  xlinkHref: "#linear-gradient-4"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-6",
  x1: 1.774,
  y1: 101.862,
  x2: 1.745,
  y2: 59.469,
  xlinkHref: "#linear-gradient-4"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-7",
  x1: 2.762,
  y1: 101.402,
  x2: 2.711,
  y2: 59.017,
  xlinkHref: "#linear-gradient-4"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-8",
  x1: 3.419,
  y1: 95.688,
  x2: 3.353,
  y2: 55.164,
  xlinkHref: "#linear-gradient-4"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-9",
  x1: 2.952,
  y1: 92.542,
  x2: 2.896,
  y2: 52.494,
  xlinkHref: "#linear-gradient-4"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-10",
  x1: 3.424,
  y1: 83.093,
  x2: 3.358,
  y2: 47.036,
  xlinkHref: "#linear-gradient-4"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-11",
  x1: 3.679,
  y1: 96.751,
  x2: 3.607,
  y2: 54.004,
  xlinkHref: "#linear-gradient-4"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-12",
  x1: 2.04,
  y1: 86.878,
  x2: 2.005,
  y2: 48.357,
  xlinkHref: "#linear-gradient-4"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-13",
  x1: 2.944,
  y1: 77.791,
  x2: 2.889,
  y2: 37.743,
  xlinkHref: "#linear-gradient-4"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-14",
  x1: 4.508,
  y1: 81.034,
  x2: 4.417,
  y2: 38.283,
  xlinkHref: "#linear-gradient-4"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-15",
  x1: 1.774,
  y1: 79.946,
  x2: 1.745,
  y2: 37.552,
  xlinkHref: "#linear-gradient-4"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-16",
  x1: 2.762,
  y1: 79.494,
  x2: 2.711,
  y2: 37.1,
  xlinkHref: "#linear-gradient-4"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-17",
  x1: 3.419,
  y1: 74.752,
  x2: 3.353,
  y2: 34.224,
  xlinkHref: "#linear-gradient-4"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-18",
  x1: 2.952,
  y1: 71.838,
  x2: 2.896,
  y2: 31.791,
  xlinkHref: "#linear-gradient-4"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-19",
  x1: 3.424,
  y1: 64.456,
  x2: 3.358,
  y2: 28.399,
  xlinkHref: "#linear-gradient-4"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-20",
  x1: 3.679,
  y1: 74.654,
  x2: 3.607,
  y2: 31.907,
  xlinkHref: "#linear-gradient-4"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-21",
  x1: 2.04,
  y1: 66.969,
  x2: 2.005,
  y2: 28.445,
  xlinkHref: "#linear-gradient-4"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-22",
  x1: 2.944,
  y1: 57.095,
  x2: 2.889,
  y2: 17.051,
  xlinkHref: "#linear-gradient-4"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-23",
  x1: 4.508,
  y1: 58.941,
  x2: 4.417,
  y2: 16.19,
  xlinkHref: "#linear-gradient-4"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-24",
  x1: 1.774,
  y1: 58.038,
  x2: 1.745,
  y2: 15.649,
  xlinkHref: "#linear-gradient-4"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-25",
  x1: 2.762,
  y1: 57.586,
  x2: 2.711,
  y2: 15.192,
  xlinkHref: "#linear-gradient-4"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-26",
  x1: 3.419,
  y1: 53.808,
  x2: 3.353,
  y2: 13.28,
  xlinkHref: "#linear-gradient-4"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-27",
  x1: 2.952,
  y1: 51.146,
  x2: 2.896,
  y2: 11.099,
  xlinkHref: "#linear-gradient-4"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-28",
  x1: 3.424,
  y1: 45.822,
  x2: 3.358,
  y2: 9.765,
  xlinkHref: "#linear-gradient-4"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-29",
  x1: 3.679,
  y1: 52.561,
  x2: 3.607,
  y2: 9.81,
  xlinkHref: "#linear-gradient-4"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-30",
  x1: 2.04,
  y1: 47.057,
  x2: 2.005,
  y2: 8.532,
  xlinkHref: "#linear-gradient-4"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-31",
  x1: 0.002,
  y1: 0.501,
  x2: 1,
  y2: 0.501,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#e6a7a7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.42,
  stopColor: "#ffb9b9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#e6a7a7"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-32",
  x1: -0.001,
  y1: 0.5,
  x2: 1.001,
  y2: 0.5,
  xlinkHref: "#linear-gradient-31"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-33",
  y1: 0.5,
  x2: 1.001,
  y2: 0.5,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#e6a7a7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.42,
  stopColor: "#fbb6b6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#e6a7a7"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-34",
  x1: -0.004,
  y1: 0.498,
  x2: 0.998,
  y2: 0.498,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#ffb9b9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.42,
  stopColor: "#e6a7a7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#e6a7a7"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-35",
  x1: -0.003,
  y1: 0.499,
  x2: 0.998,
  y2: 0.499,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#e6a7a7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.42,
  stopColor: "#e6a7a7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ffb9b9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-36",
  x1: 6.859,
  y1: 23.601,
  x2: 6.87,
  y2: 24.978,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#010101",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.95,
  stopColor: "#010101"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-37",
  x1: 4.406,
  y1: 1.001,
  x2: 4.554,
  y2: -0.338,
  xlinkHref: "#linear-gradient-36"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-38",
  x1: 1.533,
  y1: 0.54,
  x2: 2.533,
  y2: 0.54,
  xlinkHref: "#linear-gradient-36"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-39",
  x1: 0,
  y1: 0.5,
  x2: 1,
  y2: 0.5,
  xlinkHref: "#linear-gradient-36"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-40",
  x1: 0.509,
  y1: -0.382,
  x2: 0.465,
  y2: 3.651,
  xlinkHref: "#linear-gradient-36"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-41",
  x1: 3.681,
  y1: 0.647,
  x2: 3.692,
  y2: 1.701,
  xlinkHref: "#linear-gradient-36"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-42",
  x1: 3.203,
  y1: 0.332,
  x2: 3.514,
  y2: 1.724,
  xlinkHref: "#linear-gradient-36"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-43",
  x1: 4.188,
  y1: 0.304,
  x2: 3.502,
  y2: 1.755,
  xlinkHref: "#linear-gradient-36"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-44",
  x1: 3.764,
  y1: 0.152,
  x2: 3.059,
  y2: 1.854,
  xlinkHref: "#linear-gradient-36"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-45",
  x1: 0.489,
  y1: -0.969,
  x2: 0.508,
  y2: 1.545,
  xlinkHref: "#linear-gradient"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "header-img",
  transform: "translate(-0.006 -0.814)"
}, /*#__PURE__*/React.createElement("path", {
  id: "bg",
  d: "M1381.132,913.156c-41.361,59.317-99.375,104.961-145.259,161.057-67.37,82.242-110.958,189.019-202.177,243.881-43.143,25.906-93.07,37.489-142,48.728-78.644,18.093-160.131,36.186-239.392,20.9-60.756-11.685-115.892-42.32-169.9-72.544l-42.731-23.987c-9.423-5.346-18.95-10.589-28.476-15.934L383.438,1259.7c-81.488-45.918-162.462-93.824-231.133-157.116C75.786,1032.338,14.961,939.884,2.317,836.637-12.35,717.318,43.78,592,142.539,523.433c54.177-37.694,118.771-58.666,171.988-97.765,83.989-61.681,130.216-160.337,187.888-247C609.294,17.989,814.83-58.907,987.914,55.307c67.267,44.342,118.154,110.2,155.539,181.617,31.594,60.208,54.828,125.521,96.839,178.978,47.974,61.064,117.811,103.35,159.789,168.7,62.88,97.8,47.666,233.087-18.95,328.555Z",
  transform: "translate(0 0)",
  fill: "#d0053e",
  opacity: 0.24
}), /*#__PURE__*/React.createElement("path", {
  id: "carpet",
  d: "M227.957,377.605c-5.037,5.517,3.221,13.193,10.28,15.866A404.731,404.731,0,0,0,382.5,420.2l-8.4,14.29a450.343,450.343,0,0,0,236.445,1.234l-11.925-18.5,69.254-3.427c11-.514,49.585,4.009,56.884-5.757,21.006-28.133-64.491-29.23-73.675-29.607q-136.83-5.723-273.83-4.42-37.351.343-74.7,1.2C290.769,375.617,235.29,369.792,227.957,377.605Z",
  transform: "translate(265.411 898.421)",
  fill: "#d0053e",
  opacity: 0.42
}), /*#__PURE__*/React.createElement("g", {
  id: "table",
  transform: "translate(368.258 873.077)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "rect435",
  width: 773.38,
  height: 37.077,
  transform: "translate(773.38 37.077) rotate(180)",
  fill: "#d0053e",
  opacity: 0.52
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect796",
  width: 41.033,
  height: 327.284,
  transform: "translate(622.316 36.865)",
  fill: "rgba(208,5,61,0.64)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect796-1",
  width: 41.033,
  height: 327.284,
  transform: "translate(95.822 37.088)",
  fill: "rgba(208,5,61,0.64)"
})), /*#__PURE__*/React.createElement("g", {
  id: "monitor-right-top",
  transform: "translate(889.327 229.467)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "rect427",
  width: 508.528,
  height: 311.867,
  rx: 11.56,
  transform: "translate(508.528 311.867) rotate(180)",
  fill: "#d0053e",
  opacity: 0.52
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect429",
  width: 508.528,
  height: 311.867,
  rx: 11.56,
  transform: "translate(508.528 311.867) rotate(180)",
  fill: "url(#linear-gradient)"
})), /*#__PURE__*/React.createElement("g", {
  id: "monitor-left-top",
  transform: "translate(167.554 134.101)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "rect423",
  width: 457.606,
  height: 504.553,
  rx: 12.14,
  transform: "translate(457.606 504.553) rotate(180)",
  fill: "#d0053e",
  opacity: 0.52
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect425",
  width: 457.606,
  height: 504.553,
  rx: 12.14,
  transform: "translate(457.606 504.553) rotate(180)",
  fill: "url(#linear-gradient-2)"
}), /*#__PURE__*/React.createElement("g", {
  id: "g943",
  transform: "translate(71.413 69.22)"
}, /*#__PURE__*/React.createElement("path", {
  id: "path597",
  d: "M152.62,113.909l85.429-44V82.657l-71.961,35.878v.411L238.049,155v12.747l-85.429-44Z",
  transform: "translate(-152.62 -41.639)",
  fill: "rgba(255,255,255,0.8)"
}), /*#__PURE__*/React.createElement("path", {
  id: "path599",
  d: "M181,195.3,232.4,61.66h12.508L193.508,195.3Z",
  transform: "translate(-83.749 -61.66)",
  fill: "rgba(255,255,255,0.8)"
}), /*#__PURE__*/React.createElement("path", {
  id: "path601",
  d: "M288.523,124.4,203.06,168.223V155.167l72.51-36.049v-.583L203.06,82.486V69.91l85.463,43.828Z",
  transform: "translate(-30.215 -41.639)",
  fill: "rgba(255,255,255,0.8)"
})), /*#__PURE__*/React.createElement("g", {
  id: "monitor-left-top-content",
  transform: "translate(49.217 351.542)",
  opacity: 0.52
}, /*#__PURE__*/React.createElement("rect", {
  id: "rect641",
  width: 26.13,
  height: 5.723,
  transform: "translate(26 20)",
  fill: "#d0053e"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect641-2",
  "data-name": "rect641",
  width: 78.13,
  height: 5.723,
  transform: "translate(56 11)",
  fill: "#d0053e"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect643",
  width: 47.7,
  height: 5.38,
  transform: "translate(0 11.103)",
  fill: "#d0053e"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect647",
  width: 19.588,
  height: 5.688,
  transform: "translate(2.81 20.205)",
  fill: "#d0053e"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect649",
  width: 41.13,
  height: 6.723,
  transform: "translate(14.85 31.308)",
  fill: "#d0053e"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect651",
  width: 65.485,
  height: 6.374,
  transform: "translate(83.085 40.308)",
  fill: "#d0053e"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect653",
  width: 60.345,
  height: 5.38,
  transform: "translate(14.747 41.376)",
  fill: "#d0053e"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect655",
  width: 124.493,
  height: 5.963,
  transform: "translate(-0.151 58.376)",
  fill: "#d0053e"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect657",
  width: 78.13,
  height: 5.723,
  transform: "translate(15 50.385)",
  fill: "#d0053e"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect659",
  width: 47.7,
  height: 5.38,
  transform: "translate(0 70.488)",
  fill: "#d0053e"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect661",
  width: 150.057,
  height: 5.414,
  transform: "translate(66.924 70.488)",
  fill: "#d0053e"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect647-2",
  "data-name": "rect647",
  width: 19.588,
  height: 5.688,
  transform: "translate(-0.19 -0.795)",
  fill: "#d0053e"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect653-2",
  "data-name": "rect653",
  width: 24.345,
  height: 6.38,
  transform: "translate(-0.253 -11.624)",
  fill: "#d0053e"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect659-2",
  "data-name": "rect659",
  width: 66.7,
  height: 6.38,
  transform: "translate(0 -25.512)",
  fill: "#d0053e"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect657-2",
  "data-name": "rect657",
  width: 78.13,
  height: 5.723,
  transform: "translate(0 -36.615)",
  fill: "#d0053e"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect647-3",
  "data-name": "rect647",
  width: 19.588,
  height: 5.688,
  transform: "translate(-0.19 -79.795)",
  fill: "#d0053e"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect641-3",
  "data-name": "rect641",
  width: 26.13,
  height: 5.723,
  transform: "translate(26 -80)",
  fill: "#d0053e"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect653-3",
  "data-name": "rect653",
  width: 60.345,
  height: 5.38,
  transform: "translate(-0.253 -70.624)",
  fill: "#d0053e"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect657-3",
  "data-name": "rect657",
  width: 78.13,
  height: 5.723,
  transform: "translate(6 -61.615)",
  fill: "#d0053e"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect653-4",
  "data-name": "rect653",
  width: 60.345,
  height: 5.38,
  transform: "translate(6.747 -52.624)",
  fill: "#d0053e"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect647-4",
  "data-name": "rect647",
  width: 19.588,
  height: 5.688,
  transform: "translate(2.81 -43.795)",
  fill: "#d0053e"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect661-2",
  "data-name": "rect661",
  width: 114.057,
  height: 5.414,
  transform: "translate(34.924 -43.512)",
  fill: "#d0053e"
}))), /*#__PURE__*/React.createElement("g", {
  id: "monitor-main",
  transform: "translate(476.166 388.365)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "rect437",
  width: 591.969,
  height: 437.012,
  rx: 12.56,
  transform: "translate(591.969 437.012) rotate(180)",
  fill: "#08fdd8"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect439",
  width: 591.969,
  height: 437.012,
  rx: 12.56,
  transform: "translate(591.969 437.012) rotate(180)",
  fill: "url(#linear-gradient-3)"
}), /*#__PURE__*/React.createElement("g", {
  id: "monitor-main-content",
  transform: "translate(72.784 68.432)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "rect441",
  width: 118.051,
  height: 8.67,
  fill: "url(#linear-gradient-4)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect443",
  width: 72.064,
  height: 8.121,
  transform: "translate(0 16.757)",
  fill: "url(#linear-gradient-5)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect445",
  width: 226.747,
  height: 8.19,
  transform: "translate(101.123 16.757)",
  fill: "url(#linear-gradient-6)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect447",
  width: 127.612,
  height: 8.19,
  transform: "translate(349.082 16.757)",
  fill: "url(#linear-gradient-7)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect449",
  width: 99.067,
  height: 8.567,
  transform: "translate(37.488 33.582)",
  fill: "url(#linear-gradient-8)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect451",
  width: 118.051,
  height: 8.67,
  transform: "translate(69.289 50.304)",
  fill: "url(#linear-gradient-9)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect453",
  width: 98.964,
  height: 9.629,
  transform: "translate(195.05 50.304)",
  fill: "url(#linear-gradient-10)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect455",
  width: 91.151,
  height: 8.121,
  transform: "translate(69.117 67.061)",
  fill: "url(#linear-gradient-11)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect457",
  width: 188.128,
  height: 9.012,
  transform: "translate(169.007 67.061)",
  fill: "url(#linear-gradient-12)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect459",
  width: 118.051,
  height: 8.67,
  transform: "translate(0 89.746)",
  fill: "url(#linear-gradient-13)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect461",
  width: 72.064,
  height: 8.121,
  transform: "translate(0 106.503)",
  fill: "url(#linear-gradient-14)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect463",
  width: 226.747,
  height: 8.19,
  transform: "translate(101.123 106.503)",
  fill: "url(#linear-gradient-15)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect465",
  width: 127.612,
  height: 8.19,
  transform: "translate(349.082 106.503)",
  fill: "url(#linear-gradient-16)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect467",
  width: 99.067,
  height: 8.567,
  transform: "translate(37.488 123.26)",
  fill: "url(#linear-gradient-17)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect469",
  width: 118.051,
  height: 8.67,
  transform: "translate(69.289 140.051)",
  fill: "url(#linear-gradient-18)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect471",
  width: 98.964,
  height: 9.629,
  transform: "translate(195.05 140.051)",
  fill: "url(#linear-gradient-19)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect473",
  width: 91.151,
  height: 8.121,
  transform: "translate(69.117 156.807)",
  fill: "url(#linear-gradient-20)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect475",
  width: 188.128,
  height: 9.012,
  transform: "translate(169.007 156.807)",
  fill: "url(#linear-gradient-21)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect477",
  width: 118.051,
  height: 8.67,
  transform: "translate(0 179.458)",
  fill: "url(#linear-gradient-22)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect479",
  width: 72.064,
  height: 8.121,
  transform: "translate(0 196.215)",
  fill: "url(#linear-gradient-23)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect481",
  width: 226.747,
  height: 8.19,
  transform: "translate(101.123 196.215)",
  fill: "url(#linear-gradient-24)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect483",
  width: 127.612,
  height: 8.19,
  transform: "translate(349.082 196.215)",
  fill: "url(#linear-gradient-25)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect485",
  width: 99.067,
  height: 8.567,
  transform: "translate(37.488 212.972)",
  fill: "url(#linear-gradient-26)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect487",
  width: 118.051,
  height: 8.67,
  transform: "translate(69.289 229.728)",
  fill: "url(#linear-gradient-27)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect489",
  width: 98.964,
  height: 9.629,
  transform: "translate(195.05 229.728)",
  fill: "url(#linear-gradient-28)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect491",
  width: 91.151,
  height: 8.121,
  transform: "translate(69.117 246.519)",
  fill: "url(#linear-gradient-29)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect493",
  width: 188.128,
  height: 9.012,
  transform: "translate(169.007 246.519)",
  fill: "url(#linear-gradient-30)"
}))), /*#__PURE__*/React.createElement("g", {
  id: "person-and-chair",
  transform: "translate(625.126 496.386)"
}, /*#__PURE__*/React.createElement("g", {
  id: "g496",
  transform: "translate(7.08)"
}, /*#__PURE__*/React.createElement("g", {
  id: "g470",
  transform: "translate(35.088 439.879)"
}, /*#__PURE__*/React.createElement("path", {
  id: "path421",
  d: "M390.246,299.024a46.4,46.4,0,0,1,7.154,28.168c-.864,29.778-18.7,56.13-27.648,84.606-13.409,43.006-5.944,89.1-4.6,134.225a41.748,41.748,0,0,1-2.281,18.367,15.515,15.515,0,0,1-14.55,9.869,19.453,19.453,0,0,1-11.577-6.854c-21.98-23.3-21.254-58.837-24.883-90.5-4.078-35.261-15.1-69.323-24.5-103.556-4.251-15.455-8.225-31.286-7.223-47.255s7.776-32.383,21.081-41.429c24.157-16.38,71.78-10.143,89.026,14.358Z",
  transform: "translate(-279.983 -275.55)",
  fill: "#1a1a1a"
}), /*#__PURE__*/React.createElement("g", {
  id: "g430",
  transform: "translate(28.282 278.054)"
}, /*#__PURE__*/React.createElement("path", {
  id: "path581",
  d: "M313.125,360.865c-6.912,5.654-8.64,15.455-11.681,23.987-4.216,11.651-12.027,22.274-13.063,34.576a19.319,19.319,0,0,0,1.763,10.726,17.312,17.312,0,0,0,15,8.327,32.684,32.684,0,0,0,17.038-5.14,59.211,59.211,0,0,0,21.565-21.965,37.276,37.276,0,0,0,4.907-14.461C350.035,381.46,333.861,344.279,313.125,360.865Z",
  transform: "translate(-288.236 -356.692)",
  fill: "#d0053e"
}), /*#__PURE__*/React.createElement("path", {
  id: "path583",
  d: "M291.739,410.509a6.257,6.257,0,0,0,0,5.86,5.474,5.474,0,0,0,3.041,1.611,19.876,19.876,0,0,0,13.824-2.5A57.451,57.451,0,0,0,319.7,406.6a79.826,79.826,0,0,0,13.547-15.181,27.229,27.229,0,0,0,4.389-19.327c-3.7-18.607-20.183-1.953-26.3,4.934a99.592,99.592,0,0,0-19.6,33.479Z",
  transform: "translate(-281.503 -339.995)",
  fill: "#010101"
}))), /*#__PURE__*/React.createElement("g", {
  id: "g464",
  transform: "translate(149.122 440.562)"
}, /*#__PURE__*/React.createElement("path", {
  id: "path419",
  d: "M427.836,361.283q-2.9,54.828-6.917,109.861a300.109,300.109,0,0,1-7.526,55.1,156.076,156.076,0,0,1-11.9,31.217c-2.186,4.283-5.3,8.944-10.214,9.424-6.2.617-10.5-5.723-12.722-11.308-11.074-27.414-11.074-57.432-11.79-86.765q-.609-22.754-1.9-45.541c-1.039-18.333-3.118-38.174-16.091-51.744-3.942-4.112-8.744-7.47-12.615-11.685-15.8-17.134-11.074-46.021,5.949-62.161,13.224-12.508,51.606-29.025,70.133-18.676,22,12.268,16.628,62.5,15.589,82.276Z",
  transform: "translate(-326.507 -275.749)",
  fill: "#1a1a1a"
}), /*#__PURE__*/React.createElement("g", {
  id: "g426",
  transform: "translate(34.546 277.043)"
}, /*#__PURE__*/React.createElement("path", {
  id: "path577",
  d: "M373.519,360.72c7.168,5.654,8.959,15.455,12.113,23.987,4.372,11.651,12.471,22.239,13.546,34.576a18.58,18.58,0,0,1-1.828,10.691,18.106,18.106,0,0,1-15.553,8.361,35.17,35.17,0,0,1-17.668-5.14,60.569,60.569,0,0,1-22.362-21.965,36.586,36.586,0,0,1-5.089-14.461C335.209,381.315,351.981,344.272,373.519,360.72Z",
  transform: "translate(-336.589 -356.597)",
  fill: "#d0053e"
}), /*#__PURE__*/React.createElement("path", {
  id: "path579",
  d: "M385.171,410.1a5.964,5.964,0,0,1,0,5.86,5.636,5.636,0,0,1-3.118,1.611,20.844,20.844,0,0,1-14.335-2.5,57.92,57.92,0,0,1-11.54-8.875,81.564,81.564,0,0,1-14.012-15.146,26.463,26.463,0,0,1-4.551-19.361c3.8-18.573,20.929-1.919,27.236,4.934a98.449,98.449,0,0,1,20.32,33.479Z",
  transform: "translate(-334.873 -340.597)",
  fill: "#010101"
}))), /*#__PURE__*/React.createElement("g", {
  id: "g782",
  transform: "translate(0.089 312.504)"
}, /*#__PURE__*/React.createElement("path", {
  id: "path551",
  d: "M389.364,278.544c2.433,6.853,4.729,14.05,3.221,21.109a20.561,20.561,0,0,1-2.913,6.853c-6.854,10.623-23.1,12.268-34.267,5.894s-17.476-18.573-20.56-30.841a33.143,33.143,0,0,1-1.2-12.679c.994-7.436,5.928-13.707,11.068-19.19,6.853-7.128,19.43-16.448,28.647-7.881C381.654,249.486,385.7,268.3,389.364,278.544Z",
  transform: "translate(-107.042 -238.379)",
  fill: "url(#linear-gradient-31)"
}), /*#__PURE__*/React.createElement("path", {
  id: "path553",
  d: "M269.451,274.556a17.613,17.613,0,0,0-2.022,9.218,16.071,16.071,0,0,0,2.4,5.757A46.228,46.228,0,0,0,281.17,303a23.542,23.542,0,0,0,16.482,5.106c8.772-.959,15.729-7.916,20.389-15.42a42.251,42.251,0,0,0,7.3-24.193,30.841,30.841,0,0,0-12.61-23.1c-6.613-4.8-20.389-9.149-27.859-3.667s-11.685,23.987-15.42,32.828Z",
  transform: "translate(-267.402 -236.446)",
  fill: "url(#linear-gradient-32)"
})), /*#__PURE__*/React.createElement("path", {
  id: "path563",
  d: "M506.267,229.787c-34.747-28.819-84.88-28.1-129.6-22-18.47,2.5-37.283,5.825-53.526,15.009-27.208,15.42-43.314,45.233-51.778,75.388-4.489,16-6.853,34.267,2.125,48.317,9.424,14.529,28.2,19.532,45.4,21.451a15.18,15.18,0,0,1,7.47,2.159,13.26,13.26,0,0,1,4.181,8.4c4.8,25.015-4.935,53.115,7.916,75.08,12.439,21.211,40.23,26.8,64.731,28.682,31.7,2.433,66.068,1.542,91.8-17.134A37.249,37.249,0,0,0,505.65,454.2c4.249-7.265,4.489-16.106,4.592-24.5.274-18.3-6.408-55.1,2.5-71.242,7.47-13.433,28.75-13.5,36.221-28.853,14.152-29.2-21.417-82.207-42.7-99.821Z",
  transform: "translate(-267.376 -8.396)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path559",
  d: "M357.1,231.872a30.4,30.4,0,0,1,.548,9.458c-1.268,8.772-10.006,14.906-18.779,16s-17.545-1.85-25.735-5.106a20.56,20.56,0,0,1-6.853-3.906,15.25,15.25,0,0,1-3.941-7.573,55,55,0,0,1-.891-15.009L302,208.057a21.178,21.178,0,0,1,1.987-10.04c3.427-5.86,11.274-6.854,18.093-7.3,8.944-.377,22.411,0,28.3,8.156s5.209,23.507,6.716,33Z",
  transform: "translate(-185.097 -41.768)",
  fill: "url(#linear-gradient-33)"
}), /*#__PURE__*/React.createElement("g", {
  id: "head",
  transform: "translate(70.086)"
}, /*#__PURE__*/React.createElement("path", {
  id: "path561",
  d: "M417.295,192.954a52.393,52.393,0,0,1,2.741,23.3,436.4,436.4,0,0,1-5.688,54.245c-2.262,13.467-5.826,27.928-16.483,36.426a68.178,68.178,0,0,0-8.6,6.853c-1.85,1.988-3.153,4.455-4.866,6.614-8.67,10.863-26.146,10.863-38.071,3.632s-19.567-19.635-26.557-31.7c-7.71-13.3-15.352-27.208-16.723-42.526-1.131-12.131,1.713-24.912-2.913-36.186-3.427-8.293-10.52-14.941-12.1-23.747a39.989,39.989,0,0,1,2.125-17.545c2.776-9.972,7.025-21.486,17.134-24.193,7.367-1.987,14.975,1.782,22.617,2.022,9.732.343,19.635-5.106,28.887-2.022,11.891,3.975,17.134,17.682,28.99,22.137s23.987,10.075,29.5,22.685Z",
  transform: "translate(-287.829 -147.183)",
  fill: "#331b0b"
}), /*#__PURE__*/React.createElement("path", {
  id: "path557",
  d: "M297.142,174.892a8.5,8.5,0,0,0-4.146,0,8.6,8.6,0,0,0-4.934,7.847,36.472,36.472,0,0,0,.617,9.629,26.591,26.591,0,0,0,6.237,14.358,11.65,11.65,0,0,0,14.221,2.467C323.7,199.119,309.992,177.7,297.142,174.892Z",
  transform: "translate(-287.475 -80.564)",
  fill: "url(#linear-gradient-34)"
}), /*#__PURE__*/React.createElement("path", {
  id: "path555",
  d: "M338.75,176.282a8.293,8.293,0,0,1,7.2,1.268,9.561,9.561,0,0,1,2.364,5.86,41.982,41.982,0,0,1,.514,13.261,18.2,18.2,0,0,1-6.065,11.343,26.25,26.25,0,0,1-8.635,4.18,9.766,9.766,0,0,1-7.4.274,8.532,8.532,0,0,1-3.7-6.339c-2.707-13.261,1.439-27.242,15.729-29.847Z",
  transform: "translate(-204.315 -77.362)",
  fill: "url(#linear-gradient-35)"
}))), /*#__PURE__*/React.createElement("g", {
  id: "g770",
  transform: "translate(0 277.521)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "rect603",
  width: 286.03,
  height: 88.718,
  rx: 12.55,
  transform: "translate(286.03 320.331) rotate(180)",
  fill: "#d0053e"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect605",
  width: 286.03,
  height: 88.718,
  rx: 12.55,
  transform: "translate(286.03 320.331) rotate(180)",
  fill: "url(#linear-gradient-36)"
}), /*#__PURE__*/React.createElement("path", {
  id: "path591",
  d: "M379.879,379.074c3.975,3.255,7.847,7.333,12.953,7.95,3.7.411,7.4-1.165,11.171-1.165a20.972,20.972,0,0,1,13.193,5.928,22.306,22.306,0,0,1,7.265,10.28c2.776,9.458-5.654,19.806-15.489,20.766s-19.292-5.757-23.61-14.6a32.214,32.214,0,0,0-3.632-6.854,19.914,19.914,0,0,0-4.9-3.838A143.505,143.505,0,0,0,329.438,378.8c-2.913-.583-6.477-.857-8.327,1.439a8.086,8.086,0,0,0-1.405,4.455,156.668,156.668,0,0,0-.925,20.56,7.778,7.778,0,0,0,.72,3.838,13.7,13.7,0,0,0,3.221,3.187,13.364,13.364,0,0,1,1.782,15.934,24.4,24.4,0,0,1-13.4,10.28c-6.579,2.433-14.872,2.844-19.772-2.193a14.084,14.084,0,0,1-2.57-14.529,21.759,21.759,0,0,1,10.28-11.171,8.911,8.911,0,0,0,4.044-3.084,7.952,7.952,0,0,0,.617-4.112l-.48-15.283a7.368,7.368,0,0,0-2.33-6.34,6.854,6.854,0,0,0-4.455-.651,133.644,133.644,0,0,0-69.563,26.077c3.7,2.878,3.05,9.115-.274,12.4a18.025,18.025,0,0,1-13.09,4.044,26.215,26.215,0,0,1-14.632-4.283,15.146,15.146,0,0,1-6.853-13.159,15.317,15.317,0,0,1,9.15-12.062,27.413,27.413,0,0,1,15.523-1.679,31.628,31.628,0,0,0,8.19.651,24.769,24.769,0,0,0,8.635-3.6,191.42,191.42,0,0,1,77.2-23.987c22.753-2.022,50.75-1.542,69.151,13.536Z",
  transform: "translate(-159.163 109.099)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect589",
  width: 17.888,
  height: 115.412,
  transform: "translate(158.932 478.578) rotate(180)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path585",
  d: "M270.419,377.577A36.119,36.119,0,0,1,252.7,381a77.728,77.728,0,0,1-20.149-1.474,14.082,14.082,0,0,1-6.1-2.844,13.914,13.914,0,0,1-3.427-4.866c-5.586-12.336-11.891-37.9-3.221-48.283,9.9-11.925,49.208-14.015,61.681-1.508C293.584,333.749,284.812,369.113,270.419,377.577Z",
  transform: "translate(-102.098 -14.926)",
  fill: "#d0053e"
}), /*#__PURE__*/React.createElement("path", {
  id: "path587",
  d: "M270.419,377.577A36.119,36.119,0,0,1,252.7,381a77.728,77.728,0,0,1-20.149-1.474,14.082,14.082,0,0,1-6.1-2.844,13.914,13.914,0,0,1-3.427-4.866c-5.586-12.336-11.891-37.9-3.221-48.283,9.9-11.925,49.208-14.015,61.681-1.508C293.584,333.749,284.812,369.113,270.419,377.577Z",
  transform: "translate(-102.098 -14.926)",
  fill: "url(#linear-gradient-37)"
}), /*#__PURE__*/React.createElement("path", {
  id: "path565",
  d: "M265.584,332.595l.24,38.962a7.5,7.5,0,0,1-.822,4.352,6.853,6.853,0,0,1-4.592,2.5c-10.554,2.467-21.588,1.062-32.417,1.1s-22.514,1.953-30.292,9.526c11.822,8.738,27.071,11.137,41.7,12.85q32.485,3.872,65.108,5.14a168.636,168.636,0,0,0,42.183-2.193,78.233,78.233,0,0,0,33.445-15.591c-9.561-10.28-25.392-10.075-39.373-10.075a358.925,358.925,0,0,1-40.71-2.33,11.137,11.137,0,0,1-8.19-3.427,10.863,10.863,0,0,1-1.3-6.682,135.253,135.253,0,0,1,3.255-25.7,16.279,16.279,0,0,1,3.255-7.642,18.094,18.094,0,0,1,10.9-4.318A237.638,237.638,0,0,0,354.4,316.386a52.943,52.943,0,0,0,16.962-9.355c13.5-12.268,12.919-33.411,9.8-51.4a172.4,172.4,0,0,1-81.625,23.233c-19.635.548-62.23-7.881-76.039,11.034-6.853,9.561.445,18.4,8.018,25.015,3.29,2.81,34.062,17.3,34.062,17.682Z",
  transform: "translate(-145.374 -155.535)",
  fill: "url(#linear-gradient-38)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect567",
  width: 196.626,
  height: 139.365,
  rx: 16.79,
  transform: "translate(51.47)",
  fill: "#d0053e"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect569",
  width: 196.626,
  height: 139.365,
  rx: 16.79,
  transform: "translate(51.47)",
  fill: "url(#linear-gradient-39)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect571",
  width: 196.626,
  height: 139.365,
  rx: 16.79,
  transform: "translate(51.47 12.816)",
  fill: "#d0053e"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect575",
  width: 26.831,
  height: 221.504,
  rx: 3.91,
  transform: "translate(159.926 289.868) rotate(180)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path573",
  d: "M370.052,284.429a75.15,75.15,0,0,1-18.436,5.483c-17.134,3.153-37.146,2.467-49.482-9.972a22,22,0,0,1-4.626-6.579c-3.427-8.327,1.062-18.367,8.43-23.644s16.723-6.682,25.735-7.128c11.034-.548,32.006-2.433,41.635,5,11.514,8.91,9.732,30.738-3.255,36.837Z",
  transform: "translate(-190.012 -194.683)",
  fill: "url(#linear-gradient-40)"
}))), /*#__PURE__*/React.createElement("g", {
  id: "flower",
  transform: "translate(336.431 946.511)"
}, /*#__PURE__*/React.createElement("path", {
  id: "path665",
  d: "M128.625,449.189c-11.342-22.411-25.221-45.678-22.548-70.659,1.611-15.112,9.252-28.819,16.722-42.08l33.651-59.66c10.28,13.364,27.208,21.486,33.993,36.906,10.9,24.775-10.28,52.189-9.149,79.226.754,20.8,14.564,39.75,13.707,60.551-.548,15.112-24.467,64.628-43.828,62.744-10.246-.994-16.106-54.348-22.548-67.027Z",
  transform: "translate(-79.836 -276.79)",
  fill: "#d0053e"
}), /*#__PURE__*/React.createElement("path", {
  id: "path667",
  d: "M128.625,449.189c-11.342-22.411-25.221-45.678-22.548-70.659,1.611-15.112,9.252-28.819,16.722-42.08l33.651-59.66c10.28,13.364,27.208,21.486,33.993,36.906,10.9,24.775-10.28,52.189-9.149,79.226.754,20.8,14.564,39.75,13.707,60.551-.548,15.112-24.467,64.628-43.828,62.744-10.246-.994-16.106-54.348-22.548-67.027Z",
  transform: "translate(-79.836 -276.79)",
  fill: "url(#linear-gradient-41)"
}), /*#__PURE__*/React.createElement("path", {
  id: "path669",
  d: "M205.505,324.331c7.642,0,17.134,1.542,19.327,8.91,1.782,6.442-3.872,12.37-9.252,16.346-18.744,13.707-42.217,24.227-51.4,45.575-15.249,35.432-58.426,12.713-36.083-17.956,9.252-12.679,17.134-29.71,28.647-40.3C169.97,324.673,188.474,324.125,205.505,324.331Z",
  transform: "translate(-40.858 -161.493)",
  fill: "#d0053e"
}), /*#__PURE__*/React.createElement("path", {
  id: "path671",
  d: "M205.505,324.331c7.642,0,17.134,1.542,19.327,8.91,1.782,6.442-3.872,12.37-9.252,16.346-18.744,13.707-42.217,24.227-51.4,45.575-15.249,35.432-58.426,12.713-36.083-17.956,9.252-12.679,17.134-29.71,28.647-40.3C169.97,324.673,188.474,324.125,205.505,324.331Z",
  transform: "translate(-40.858 -161.493)",
  fill: "url(#linear-gradient-42)"
}), /*#__PURE__*/React.createElement("path", {
  id: "path673",
  d: "M150.878,344.187c-8.6-9.8-21.383-14.632-33.582-19.155-5.791-2.125-13.227-3.872-17.134.788a10.76,10.76,0,0,0,0,12.439,38.855,38.855,0,0,0,9.7,9.081,61.2,61.2,0,0,1,17.99,20.869c4.352,8.875,5.517,18.984,9.389,28.1s11.959,17.716,21.828,17.3a19.669,19.669,0,0,0,16.859-13.878c3.838-11.822-1.268-17.134-7.607-25.5-7.025-9.286-9.595-21.177-17.442-30.052Z",
  transform: "translate(-98.182 -164.969)",
  fill: "#d0053e"
}), /*#__PURE__*/React.createElement("path", {
  id: "path675",
  d: "M150.878,344.187c-8.6-9.8-21.383-14.632-33.582-19.155-5.791-2.125-13.227-3.872-17.134.788a10.76,10.76,0,0,0,0,12.439,38.855,38.855,0,0,0,9.7,9.081,61.2,61.2,0,0,1,17.99,20.869c4.352,8.875,5.517,18.984,9.389,28.1s11.959,17.716,21.828,17.3a19.669,19.669,0,0,0,16.859-13.878c3.838-11.822-1.268-17.134-7.607-25.5-7.025-9.286-9.595-21.177-17.442-30.052Z",
  transform: "translate(-98.182 -164.969)",
  fill: "url(#linear-gradient-43)"
}), /*#__PURE__*/React.createElement("path", {
  id: "path677",
  d: "M198.9,345.07,187.351,453.115H175.117c-9.424-5.346-18.95-10.589-28.476-15.934l-27.757-15.557L109.05,345.07Z",
  transform: "translate(-71.809 -111.093)",
  fill: "#d0053e"
}), /*#__PURE__*/React.createElement("path", {
  id: "path679",
  d: "M198.9,345.07,187.351,453.115H175.117c-9.424-5.346-18.95-10.589-28.476-15.934l-27.757-15.557L109.05,345.07Z",
  transform: "translate(-71.809 -111.093)",
  fill: "url(#linear-gradient-44)"
})), /*#__PURE__*/React.createElement("g", {
  id: "monitor-left",
  transform: "translate(179.959 695.503)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "rect595",
  width: 335.717,
  height: 123.157,
  rx: 10.67,
  transform: "translate(335.717 123.157) rotate(180)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("g", {
  id: "monitor-left-content",
  transform: "translate(51.812 27.14)",
  opacity: 0.52
}, /*#__PURE__*/React.createElement("rect", {
  id: "rect641-4",
  "data-name": "rect641",
  width: 78.13,
  height: 5.723,
  transform: "translate(0)",
  fill: "#d0053e"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect643-2",
  "data-name": "rect643",
  width: 47.7,
  height: 5.38,
  transform: "translate(0 11.103)",
  fill: "#d0053e"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect645",
  width: 150.057,
  height: 5.414,
  transform: "translate(66.924 11.103)",
  fill: "#d0053e"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect647-5",
  "data-name": "rect647",
  width: 65.588,
  height: 5.688,
  transform: "translate(24.81 22.205)",
  fill: "#d0053e"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect649-2",
  "data-name": "rect649",
  width: 78.13,
  height: 5.723,
  transform: "translate(45.85 33.308)",
  fill: "#d0053e"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect651-2",
  "data-name": "rect651",
  width: 65.485,
  height: 6.374,
  transform: "translate(129.085 33.308)",
  fill: "#d0053e"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect653-5",
  "data-name": "rect653",
  width: 60.345,
  height: 5.38,
  transform: "translate(45.747 44.376)",
  fill: "#d0053e"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect655-2",
  "data-name": "rect655",
  width: 124.493,
  height: 5.963,
  transform: "translate(111.849 44.376)",
  fill: "#d0053e"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect657-4",
  "data-name": "rect657",
  width: 78.13,
  height: 5.723,
  transform: "translate(0 59.385)",
  fill: "#d0053e"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect659-3",
  "data-name": "rect659",
  width: 47.7,
  height: 5.38,
  transform: "translate(0 70.488)",
  fill: "#d0053e"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect661-3",
  "data-name": "rect661",
  width: 150.057,
  height: 5.414,
  transform: "translate(66.924 70.488)",
  fill: "#d0053e"
}))), /*#__PURE__*/React.createElement("g", {
  id: "monitor-middle",
  transform: "translate(772.784 117.584)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "rect431",
  width: 319.475,
  height: 195.941,
  rx: 7.26,
  transform: "translate(319.475 195.941) rotate(180)",
  fill: "#d0053e",
  opacity: 0.52
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect433",
  width: 319.475,
  height: 195.941,
  rx: 7.26,
  transform: "translate(319.475 195.941) rotate(180)",
  fill: "url(#linear-gradient-45)"
}), /*#__PURE__*/React.createElement("g", {
  id: "g549",
  transform: "translate(40.538 26.797)",
  opacity: 0.52
}, /*#__PURE__*/React.createElement("rect", {
  id: "rect495",
  width: 58.734,
  height: 4.318,
  fill: "#d0053e"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect497",
  width: 35.844,
  height: 4.044,
  transform: "translate(0 8.361)",
  fill: "#d0053e"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect499",
  width: 112.808,
  height: 4.078,
  transform: "translate(50.304 8.361)",
  fill: "#d0053e"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect501",
  width: 63.497,
  height: 4.078,
  transform: "translate(173.633 8.361)",
  fill: "#d0053e"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect503",
  width: 49.276,
  height: 4.249,
  transform: "translate(18.641 16.688)",
  fill: "#d0053e"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect505",
  width: 58.734,
  height: 4.318,
  transform: "translate(34.473 25.049)",
  fill: "#d0053e"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect507",
  width: 49.208,
  height: 4.797,
  transform: "translate(97.011 25.049)",
  fill: "#d0053e"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect509",
  width: 45.336,
  height: 4.044,
  transform: "translate(34.37 33.376)",
  fill: "#d0053e"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect511",
  width: 93.584,
  height: 4.489,
  transform: "translate(84.092 33.376)",
  fill: "#d0053e"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect513",
  width: 58.734,
  height: 4.318,
  transform: "translate(0 44.65)",
  fill: "#d0053e"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect515",
  width: 35.844,
  height: 4.044,
  transform: "translate(0 52.977)",
  fill: "#d0053e"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect517",
  width: 112.808,
  height: 4.078,
  transform: "translate(50.304 52.977)",
  fill: "#d0053e"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect519",
  width: 63.497,
  height: 4.078,
  transform: "translate(173.633 52.977)",
  fill: "#d0053e"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect521",
  width: 49.276,
  height: 4.249,
  transform: "translate(18.641 61.304)",
  fill: "#d0053e"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect523",
  width: 58.734,
  height: 4.318,
  transform: "translate(34.473 69.666)",
  fill: "#d0053e"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect525",
  width: 49.208,
  height: 4.797,
  transform: "translate(97.011 69.666)",
  fill: "#d0053e"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect527",
  width: 45.336,
  height: 4.044,
  transform: "translate(34.37 77.993)",
  fill: "#d0053e"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect529",
  width: 93.584,
  height: 4.489,
  transform: "translate(84.092 77.993)",
  fill: "#d0053e"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect531",
  width: 58.734,
  height: 4.318,
  transform: "translate(0 89.266)",
  fill: "#d0053e"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect533",
  width: 35.844,
  height: 4.044,
  transform: "translate(0 97.628)",
  fill: "#d0053e"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect535",
  width: 112.808,
  height: 4.078,
  transform: "translate(50.304 97.628)",
  fill: "#d0053e"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect537",
  width: 63.497,
  height: 4.078,
  transform: "translate(173.633 97.628)",
  fill: "#d0053e"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect539",
  width: 49.276,
  height: 4.249,
  transform: "translate(18.641 105.955)",
  fill: "#d0053e"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect541",
  width: 58.734,
  height: 4.318,
  transform: "translate(34.473 114.282)",
  fill: "#d0053e"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect543",
  width: 49.208,
  height: 4.797,
  transform: "translate(97.011 114.282)",
  fill: "#d0053e"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect545",
  width: 45.336,
  height: 4.044,
  transform: "translate(34.37 122.643)",
  fill: "#d0053e"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect547",
  width: 93.584,
  height: 4.489,
  transform: "translate(84.092 122.643)",
  fill: "#d0053e"
}))), /*#__PURE__*/React.createElement("g", {
  id: "monitor-right",
  transform: "translate(1025.677 584.203)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "rect593",
  width: 291.992,
  height: 216.535,
  rx: 11.02,
  transform: "translate(291.992 216.535) rotate(180)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("g", {
  id: "g639",
  transform: "translate(32.417 56.027)",
  opacity: 0.52
}, /*#__PURE__*/React.createElement("rect", {
  id: "rect607",
  width: 78.13,
  height: 5.723,
  fill: "#d0053e"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect609",
  width: 47.7,
  height: 5.38,
  transform: "translate(0 11.068)",
  fill: "#d0053e"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect611",
  width: 150.057,
  height: 5.414,
  transform: "translate(66.924 11.068)",
  fill: "#d0053e"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect613",
  width: 65.588,
  height: 5.688,
  transform: "translate(24.81 22.205)",
  fill: "#d0053e"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect615",
  width: 78.13,
  height: 5.723,
  transform: "translate(45.85 33.274)",
  fill: "#d0053e"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect617",
  width: 65.485,
  height: 6.374,
  transform: "translate(129.051 33.274)",
  fill: "#d0053e"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect619",
  width: 60.345,
  height: 5.38,
  transform: "translate(45.713 44.376)",
  fill: "#d0053e"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect621",
  width: 124.493,
  height: 5.963,
  transform: "translate(111.849 44.376)",
  fill: "#d0053e"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect623",
  width: 78.13,
  height: 5.723,
  transform: "translate(0 59.385)",
  fill: "#d0053e"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect625",
  width: 47.7,
  height: 5.38,
  transform: "translate(0 70.454)",
  fill: "#d0053e"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect627",
  width: 150.057,
  height: 5.414,
  transform: "translate(66.924 70.454)",
  fill: "#d0053e"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect629",
  width: 65.588,
  height: 5.688,
  transform: "translate(24.81 81.556)",
  fill: "#d0053e"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect631",
  width: 78.13,
  height: 5.723,
  transform: "translate(45.85 92.659)",
  fill: "#d0053e"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect633",
  width: 65.485,
  height: 6.374,
  transform: "translate(129.051 92.659)",
  fill: "#d0053e"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect635",
  width: 60.345,
  height: 5.38,
  transform: "translate(45.713 103.762)",
  fill: "#d0053e"
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect637",
  width: 124.493,
  height: 5.963,
  transform: "translate(111.849 103.762)",
  fill: "#d0053e"
}))));

function SvgHeaderImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1440,
    height: 1392.651,
    viewBox: "0 0 1440 1392.651",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderImg);
export default __webpack_public_path__ + "static/media/header-img.c7633a8f.svg";
export { ForwardRef as ReactComponent };